export interface IPageConfigurationDatatableRow<IdType extends string | number> {
  id: IdType;
  name: string;
}

export interface IDefaultDatatableHeaderSection<IdType extends string | number> {
  headers: IPageConfigurationDatatableRow<IdType>[];
  sectionTitle: string;
}

export interface IDatatablePageConfiguration<IdType extends string | number> {
  availableColumnsBySections: IDefaultDatatableHeaderSection<IdType>[]; // All available columns, including unselected by default
  initiallySelectedHeaders: IdType[] | null;
  lockedHeaders: IdType[]; // These columns will have disabled checkboxes
  type: 'datatable';
  unselectedByDefaultHeaders: IdType[]; // If set as default is not done, which columns are not selected by default
  sortBy?: EWidgetSortBy | null;
}

export interface IPageConfigurationData {
  configurationTabs: IDatatablePageConfiguration<string | number>[]; // If more types needs to be added, define another interface just like IDatatableConfiguration and add here
  isSetAsDefaultAvailable: boolean;
}

export interface IConfigurationData<IdType extends string | number = number> {
  ids: IdType[];
  type: string;
  sortBy?: EWidgetSortBy | null;
}

export interface IApplyData<IdType extends string | number = number> {
  configurations: IConfigurationData<IdType>[];
  isSetAsDefault: boolean;
}

export enum EWidgetSortBy {
  createdAtAsc = '-8_asc',
  createdAtDesc = '-8_desc',
  dueDateAsc = '-9_asc',
  dueDateDesc = '-9_desc',
  eventDateAsc = '-12_asc',
  eventDateDesc = '-12_desc',
}
